module.exports = __webpack_public_path__ + "static/media/meh.3e503ffd.svg";